var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.setting.isMobile)?_c('div',[_c('wapHead'),_c('router-view'),(this.$route.path!='/News')?_c('ContentBottom'):_vm._e()],1):_c('div',[_c('Head'),_c('router-view'),_c('Bottom')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }